import { Component, createRef } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {set_datapage,getMapStateDefault} from '@ora/recursos/src/redux/actions/DataPageAction'

import { Button, 
  Card, 

  Section, 
  Form,
   } from 'react-bulma-components';
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from 'jquery'
import dt from 'datatables.net'
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo } from "helpers/Datatables";
import Swal from "sweetalert2";
import qs from "query-string";
import { Helpers, Redux, Templates } from "@ora/recursos";

import InputsCreate from "layouts/mainsection/components/InputsCreate";
import {PageLength} from "helpers/Datatables";
$.DataTable = dt


class Autoridades extends Component {
    state ={
        search : [],
        listaPaises : {data : []},
        listaTipo : {data : []},
    }
    constructor(props){
        super(props)
        this.props.set_datapage(
            { 
                titulo: this.props.language('autoridad_titulo'),
                isbackend:false,
                breadcrumb:false
            });

        this.txtAutoridad = createRef()
        this.slctPais = createRef()
        this.slctTipo = createRef()

    }

    componentDidMount () {
        
       
        var params = qs.parse(this.props.location.search);
        var search = this.state.search;
        if (params["name"]) {
            search['txtname']=params["name"]
        }
        if (params["pais"]) {
            search['slctPais']=params["pais"]
        }
        if (params["type"]) {
            search['slctTipo']=params["type"]
        }
        this.setState({
            search: search,
        });

        this.init()        
        axios.get(baseUrl('cites/empresas/getdatainitAutoridades')).then((res)=>{
            var params = qs.parse(this.props.location.search);
            this.traerDataSelect(res.data.paises, 'listaPaises',params["pais"]?params["pais"]:false)
            this.traerDataSelect(res.data.type, 'listaTipo',params["type"]?params["type"]:false)
            
        })


    }
    buscar_simple = () => {
        this.getSearch();
        var url = this.getParamsUrl("/pages/autoridades?");
        this.props.history.push(localUrl(url));
    };
    gestionarCambio = (event) => {
        var search = this.state.search;
        if (event.target.type === "radio") {
          search[event.target.name] = event.target.value;
        } else {
          search[event.target.id] = event.target.value;
        }
        this.setState({
          search: search,
        });
      };
    getSearch() {
        this.datatable.draw();
      }
    getFilter() {
    return {
      name: this.state.search['txtname'],
      type: this.state.search['slctTipo'],
      pais: this.state.search['slctPais'],
      module:'module_cites'    
    };
  }
  getParamsUrl(url) {
    if (this.txtAutoridad.current.value !== "") {
      url += "&name=" + this.txtAutoridad.current.value;
    }
    if (this.slctTipo.current.value != -1) {
      url += "&type=" + this.slctTipo.current.value;
    }
    if (this.slctPais.current.value != -1) {
      url += "&pais=" + this.slctPais.current.value;
    }
    return url;
  }
    traerDataSelect(data, columna,select=false){
         
        const listaSlct = data.map(item=>{
            return (<option value={item.value} selected={select===item.value?'selected':''}>{item.name} </option>)
        })
        let dataSlct = {}
        dataSlct.data = listaSlct
        this.setState({[columna] : dataSlct})
    }

    init = () => {
        
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'#show-datatable.table-container't>>><'columns'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/actor/datatableInstituciones"),
              data: (d) => {
                d.filter = this.getFilter() 
                return d
              },
              beforeSend: () => {
                this.setState({
                  totalFiltrado: 0
                })
                $('.snipperDatatable').remove()
                $('#show-datatable').append(Helpers.Spinner.htmlSpinner('snipperDatatable'))
                $('#show-datatable table').addClass('is-hidden')
                $('#tblPaises_length').addClass('is-hidden') 
                $('#tblPaises_paginate').addClass('is-hidden')
              },
              error: function (xhr, error, thrown) {
                if (!["abort"].some((v) => v === thrown)) {
                  Swal.fire({
                    title: thrown,
                    html: `
                           <p> Se encontró un error en el servidor, intente más tarde.</p>
                           <p>Mensaje: ${xhr.status} - ${error}</p>
                          `,
                    icon: "error",
                  }).then((sr) => {});
                }
              },
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
                {
                    data: "ins_int_id",
                    render: (d, t, r,m) => {
                      return m.row+1;
                    },
                },
                { data: "ins_txt_name"},
                { data: "ins_txt_description",orderable: false,
                    render: (d, t, r) => {
                        return t==='display'&&d!=null&&d.length>70?'<span title="'+d+'">'+d.substr( 0, 70 )+'...</span>' :d;
                    }
                },
                { data: "ins_txt_contact",orderable: false,
                    render: (d, t, r) => {
                    return '<div style="inline-size: 140px;overflow-wrap: break-word;">'+d+'</div>';
                    }
                },
                { data: "ins_txt_websites",orderable: false,
                    render: (d, t, r) => {
                        return '<div style="inline-size: 140px;overflow-wrap: break-word;"><a href="'+d+'">'+d+'</a></div>';
                    }
                },
                { data: "var_txt_name"},
            ],
            drawCallback: () => {
                $('.snipperDatatable').remove()
                $('#show-datatable table').removeClass('is-hidden')
                $('#tblPaises_length').removeClass('is-hidden')
                $('#tblPaises_paginate').removeClass('is-hidden')
                $('#tblPaises_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblPaises_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblPaises_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblPaises_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblPaises_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblPaises')
        
        this.datatable = this.table.DataTable(this.configDT)
        
        
    }

    render(){
        return(
                <Templates.Default.BasePageRoute2 localUrl={localUrl} dataPage={this.props.DataPage}>
                
                <div className="columns mb-5">
                    <div className="column">
                    <p className='has-text-justified'>
                    {this.props.language("autoridades_descripcion","Las Autoridades CITES, son instituciones públicas pertenecientes a los países Miembros de la OTCA que tienen responsabilidad Administrativa o Científica en temas relacionadas al Comercio Internacional de Especies Amenazadas de Fauna y Flora Silvestres")}. 
                    </p>
                  </div>
                </div>
                    <div className="columns ">
                        <div className="column mx-5">
                            <div className="columns mx-12">
                                <div className="column is-5">
                                    <InputsCreate onChange={this.gestionarCambio} referencia={this.txtAutoridad} type="text" placeholder={this.props.language("buscar_autoridad","Buscar Autoridad ...")} nameKey="txtname"></InputsCreate>
                                </div>
                                <div className="column is-4">
                                <InputsCreate nameKey="slctTipo" onChange={this.gestionarCambio} byDefault= {this.props.language("sel_todos","Todos")} type="select" referencia={this.slctTipo} forSelect={this.state.listaTipo} label={this.props.language("autoridad_tipo","Tipo")}></InputsCreate>
                                </div>
                                <div className="column is-2">
                                    <InputsCreate nameKey="slctPais" onChange={this.gestionarCambio} byDefault={this.props.language("sel_todos","Todos")} type="select" referencia={this.slctPais} forSelect={this.state.listaPaises} label={this.props.language("autoridad_pais","País")}></InputsCreate>
                                </div>
                                <div className="column is-1">
                                <button
                                    className="button is-link"
                                    onClick={this.buscar_simple}
                                    >
                                    {this.props.language("buscar","Buscar")}
                                    </button>
                                </div>
                            </div>
                            <div className="columns">
                                <div className="column">
                                    <table className="table table-cites" id="tblPaises">
                                        <thead>
                                        <tr>
                                            <th>
                                               #
                                            </th>
                                            <th>
                                                {this.props.language("autoridad_nombre","Nombre de la Autoridad")}
                                            </th>
                                            <th>
                                                {this.props.language( "autoridad_descripcion","Descripción")}
                                            </th>                                           
                                            <th>
                                                {this.props.language("autoridad_contacto","Contacto",)}
                                            </th>
                                            <th>
                                                {this.props.language("autoridad_web","Página web")}
                                            </th>
                                            <th>
                                                {this.props.language("autoridad_tipo","Tipo")}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </Templates.Default.BasePageRoute2>
        )
    }
}

export default connect(getMapStateDefault(), {set_datapage})(Autoridades)